import React from "react";
import * as Solid from "@heroicons/react/24/solid";
import PreloadImage from "react-preload-image";
import "./style.scss";

const plural = (n) => (n === 1 ? "vote" : "votes");

export const ModalVotes = ({ playback, hideModal }) => {
  // Both lists are read unguarded below, and the API wrapper only started
  // supplying them on 2026-07-15 — until then `undefined.length` threw and took
  // this modal (and the votes it exists to show) down. Defaulting here keeps the
  // modal renderable no matter what shape reaches it.
  const votesLogged = playback.votesLogged || [];
  const votesNotLogged = playback.votesNotLogged || [];
  const title = (playback.media && playback.media.title) || "this song";

  return (
    <div className="container-votes">
      <div className="body">
        <button className="close-modal" onClick={hideModal}>
          <Solid.XMarkIcon />
        </button>
        <div className="votes">
          <span className="count-votes">
            {votesLogged.length} {plural(votesLogged.length)}
          </span>
          <h2 className="title">Registered users who voted for ({title})</h2>
          <div className="list">
            {votesLogged.length === 0 && (
              <div className="empty">No votes from registered users yet.</div>
            )}
            {votesLogged.map((user, index) => {
              const name = user.name || "Unnamed user";
              const place = [user.city, user.state].filter(Boolean).join(", ");
              return (
                <div key={index} className="vote">
                  <div className="cover">
                    {user.profile_image_url ? (
                      <PreloadImage
                        className="image"
                        src={user.profile_image_url}
                        alt={name}
                        lazy
                      />
                    ) : (
                      <span className="alias">{name.charAt(0).toUpperCase()}</span>
                    )}
                  </div>
                  <div className="info">
                    <h3 className="title">{name}</h3>
                    <p className="description">{place || "—"}</p>
                  </div>
                  <Solid.HeartIcon className="heart-icon" />
                </div>
              );
            })}
          </div>
        </div>
        <div className="votes">
          <span className="count-votes">
            {votesNotLogged.length} {plural(votesNotLogged.length)}
          </span>
          {/* Guests have no account, so the email they voted with is the only
              identity that exists for them — it is shown as-is rather than
              rendering them as anonymous. */}
          <h2 className="title">Guests who voted for ({title})</h2>
          <div className="list">
            {votesNotLogged.length === 0 && (
              <div className="empty">No guest votes yet.</div>
            )}
            {votesNotLogged.map((email, index) => {
              const label = email || "Unknown email";
              return (
                <div key={index} className="vote">
                  <div className="cover">
                    <span className="alias">{label.charAt(0).toUpperCase()}</span>
                  </div>
                  <div className="info">
                    <h3 className="title">{label}</h3>
                    <p className="description">Guest — voted by email</p>
                  </div>
                  <Solid.HeartIcon className="heart-icon" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
